import { Badge } from "@/components/ui/badge";

const statusLabels: Record<string, string> = {
  draft: "Draft",
  active: "Active",
  archived: "Archived",
  inactive: "Inactive",
  pending: "Pending",
  paid: "Paid",
  shipped: "Shipped",
  cancelled: "Cancelled",
  // Fleet Relay: copy_operation.status (src/lib/enums.ts COPY_OPERATION_STATUSES).
  in_progress: "In Progress",
  completed: "Completed",
  failed: "Failed",
  rolled_back: "Rolled Back",
};

const statusStyles: Record<string, string> = {
  draft: "bg-amber-500/10 text-amber-600 dark:text-amber-400",
  active: "bg-emerald-500/10 text-emerald-600 dark:text-emerald-400",
  archived: "bg-zinc-500/10 text-zinc-600 dark:text-zinc-400",
  inactive: "bg-zinc-500/10 text-zinc-600 dark:text-zinc-400",
  pending: "bg-amber-500/10 text-amber-600 dark:text-amber-400",
  paid: "bg-sky-500/10 text-sky-600 dark:text-sky-400",
  shipped: "bg-emerald-500/10 text-emerald-600 dark:text-emerald-400",
  cancelled: "bg-rose-500/10 text-rose-600 dark:text-rose-400",
  in_progress: "bg-sky-500/10 text-sky-600 dark:text-sky-400",
  completed: "bg-emerald-500/10 text-emerald-600 dark:text-emerald-400",
  failed: "bg-rose-500/10 text-rose-600 dark:text-rose-400",
  rolled_back: "bg-rose-500/10 text-rose-600 dark:text-rose-400",
};

interface StatusBadgeProps {
  status: string;
}

export function StatusBadge({ status }: StatusBadgeProps) {
  const label = statusLabels[status] ?? status;

  return (
    <Badge variant="outline" className={`border-transparent ${statusStyles[status] ?? ""}`}>
      {label}
    </Badge>
  );
}
